export default function noop(..._args: unknown[]) {}
